/**
 * Request-lifecycle status pill. Maps the approval-request `state` machine
 * (Approval Engine Spec) onto the prototype's status-pill vocabulary, using
 * Crystal-Comms labels (no bare "Pending"). Reused by My Requests, the request
 * detail slide-over, and the form Confirmation screen.
 */

interface PillMeta {
  cls: string;
  label: string;
}

const STATUS_META: Record<string, PillMeta> = {
  submitted: { cls: "pill-submitted", label: "Submitted" },
  pending: { cls: "pill-pending", label: "Pending approval" },
  approved: { cls: "pill-approved", label: "Approved" },
  auto_approved: { cls: "pill-approved", label: "Auto-approved" },
  rejected: { cls: "pill-rejected", label: "Rejected" },
  expired: { cls: "pill-expired", label: "Expired" },
  cancelled: { cls: "pill-expired", label: "Cancelled" },
  complete: { cls: "pill-complete", label: "Completed" },
  completed: { cls: "pill-complete", label: "Completed" },
};

export function statusPillMeta(state: string): PillMeta {
  return STATUS_META[state] ?? { cls: "pill-submitted", label: state };
}

export function StatusPill({ state }: { state: string }) {
  const meta = statusPillMeta(state);
  return (
    <span className={"badge " + meta.cls}>
      <span className="dot" />
      {meta.label}
    </span>
  );
}

export default StatusPill;
